import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { AdsService } from '@app/shared/services/ads/ads.service';
import { IStoreService } from '@app/shared/services/store/store-service.interface';
import { AnalyticsEvent, LogAnalyticsEventInteractor } from '@together/common';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-web-ad-banner',
    templateUrl: './web-ad-banner.component.html',
    styleUrls: ['./web-ad-banner.component.scss'],
})
export class WebAdBannerComponent implements OnInit, OnDestroy {
    @Input() containerId!: string;
    @Input() containerClass!: string;

    public isVisible = false;

    private subs = new Subscription();

    constructor(
        private adsService: AdsService,
        @Inject('StoreService') private storeService: IStoreService,
        private logAnalyticsEvent: LogAnalyticsEventInteractor,
    ) {}

    ngOnInit(): void {
        this.subs.add(
            this.adsService.getBannerPlaceholderVisibility$(this.containerId).subscribe(isVisible => {
                this.isVisible = isVisible;
            }),
        );
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    showUpgradeModal(): void {
        this.logAnalyticsEvent.execute(AnalyticsEvent.InHouseAdBannerClicked);
        this.storeService.showUpgradeModal();
    }

    onSpace(event: KeyboardEvent): void {
        event.preventDefault();
        this.showUpgradeModal();
    }
}
